export const getWindowObject = (): (Window & typeof globalThis) | undefined => {
	return typeof window !== 'undefined' && !!window ? window : undefined;
};
